
import React from "react";
import { cn } from "@/lib/utils";
import { LeadStageType } from "@/context/LeadContext";

interface LeadStatusBadgeProps {
  status: LeadStageType;
  className?: string;
}

const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({ status, className }) => {
  const getStatusStyles = () => {
    switch (status) {
      case "Νέο":
        return "bg-blue-100 text-blue-800";
      case "σεΕκκρεμότητα":
        return "bg-amber-100 text-amber-800";
      case "έκλεισεΗΔουλειά":
        return "bg-emerald-100 text-emerald-800";
      case "ήθελεΠληροφορίες":
        return "bg-slate-100 text-slate-700";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case "Νέο":
        return "Νέο";
      case "σεΕκκρεμότητα":
        return "Σε Εκκρεμότητα";
      case "έκλεισεΗΔουλειά":
        return "Επιτυχία";
      case "ήθελεΠληροφορίες":
        return "Πληροφορίες";
      default:
        return "Άγνωστο";
    }
  };

  return (
    <span
      className={cn(
        "px-2 py-1 rounded-full text-xs font-medium",
        getStatusStyles(),
        className
      )}
    >
      {getStatusLabel()}
    </span>
  );
};

export default LeadStatusBadge;
